import React from 'react';
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { setState } from '../../../../redux/Slice/lopOvertimeRequestSlice';
import { useEditLopOvertimeRequestMutation } from '../../../../redux/apis/LOPAndOvertimeAPI';

import { getErrorMessage } from '../../../../utils/handler';
import { LB_HEADER } from '../../../../utils/constant/labels';
import { notification } from '../../../../utils/notification';
import { TOAST_TYPE } from '../../../../utils/constant/errorMessage';
import { BT_BUTTON_LABELS } from '../../../../utils/constant/buttons';
import { LOP_AND_OVERTIME_STATUS } from '../../../../utils/constant/global';
import { lopOvertimeRequestApprovedSchema } from '../../../../utils/schemas/payrun';

const { BTN_ACCEPT } = BT_BUTTON_LABELS;
const { APPROVED } = LOP_AND_OVERTIME_STATUS;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { LB_LOP_OVERTIME_APPROVE, LB_ASK_LOP_OVERTIME_APPROVE } = LB_HEADER;

const LopAndOvertimeRequestApprovedModel = () => {
  const dispatch = useDispatch();
  const lopOvertimeState = useSelector((state) => state.lopOvertimeRequest);

  const [editLopOvertimeRequest] = useEditLopOvertimeRequestMutation();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(lopOvertimeRequestApprovedSchema),
    defaultValues: {
      reason: ''
    }
  });

  const onSubmit = async (data) => {
    await handleUpdateLopOvertimeRequest(
      {
        status: APPROVED,
        statusReason: data.reason
      },
      lopOvertimeState?.isApprovedModel?.lopOvertimeId
    );
  };

  const handleUpdateLopOvertimeRequest = async (payload, id) => {
    try {
      if (!id) notification('Id not found', TOAST_ERROR);

      dispatch(setState({ ...lopOvertimeState, loading: true }));

      const res = await editLopOvertimeRequest({ data: payload, id });
      if (res.data?.success) {
        notification(res?.data?.statusMessage, TOAST_SUCCESS);
      } else {
        notification(res?.data?.statusMessage, TOAST_ERROR);
      }
      onHandleCloseDialog();
    } catch (error) {
      onHandleCloseDialog();
      notification(error.message, TOAST_ERROR);
    }
  };

  const onHandleCloseDialog = () => {
    reset();
    dispatch(
      setState({ ...lopOvertimeState, isApprovedModel: { model: false, lopOvertimeId: '' } })
    );
  };

  return (
    <Modal
      centered
      show={lopOvertimeState?.isApprovedModel?.model ? true : false}
      onHide={() => {
        onHandleCloseDialog();
      }}
    >
      <Modal.Header closeButton>
        <h5 className="modal-title fw-bold" id="dremovetaskLabel">
          {LB_LOP_OVERTIME_APPROVE}
        </h5>
      </Modal.Header>
      <Modal.Body>
        <form
          className="justify-content-center flex-column d-flex"
          onSubmit={handleSubmit(onSubmit)}
        >
          <i className="icofont-simple-smile text-success display-2 text-center mt-2"></i>
          <p className="mt-4 fs-5 text-center">{LB_ASK_LOP_OVERTIME_APPROVE}</p>
          <div className="mb-3">
            <textarea
              rows={4}
              {...register('reason')}
              className={`form-control mb-3 ${getErrorMessage('reason', errors) && 'is-invalid'}`}
              placeholder="Enter reason"
            />
            <small className="text-danger">{getErrorMessage('reason', errors)}</small>
          </div>

          <button className="btn btn-success text-white">{BTN_ACCEPT}</button>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default LopAndOvertimeRequestApprovedModel;
